import { useEffect, useRef, useState } from "react";

const KEYS = { deal: "deal_sound_muted", rare: "rare_sound_muted" };
let ctx;

export const isChompMuted = (kind = "deal") => localStorage.getItem(KEYS[kind]) === "1";
export const setChompMuted = (m, kind = "deal") => localStorage.setItem(KEYS[kind], m ? "1" : "0");

export function useChompMute(kind = "deal") {
  const [muted, setMuted] = useState(() => isChompMuted(kind));
  const toggle = () => { setChompMuted(!muted, kind); setMuted(!muted); };
  return [muted, toggle];
}

// Short synthesized "wakka-wakka" chomp plus a buzz on phones that support vibration.
export function playChomp(kind = "deal") {
  if (isChompMuted(kind)) return;
  try {
    ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
    if (ctx.state === "suspended") ctx.resume();
    const t0 = ctx.currentTime;
    [0, 0.16, 0.32].forEach((d, i) => {
      const o = ctx.createOscillator();
      const g = ctx.createGain();
      o.type = "square";
      const [a, b] = i % 2 ? [260, 520] : [520, 260];
      o.frequency.setValueAtTime(a, t0 + d);
      o.frequency.linearRampToValueAtTime(b, t0 + d + 0.13);
      g.gain.setValueAtTime(0.0001, t0 + d);
      g.gain.exponentialRampToValueAtTime(0.12, t0 + d + 0.02);
      g.gain.exponentialRampToValueAtTime(0.0001, t0 + d + 0.14);
      o.connect(g).connect(ctx.destination);
      o.start(t0 + d);
      o.stop(t0 + d + 0.15);
    });
  } catch { /* audio unsupported */ }
  if (navigator.vibrate) navigator.vibrate([90, 60, 90]);
}

// Chomp when a count goes up after the first loaded value (not on page open).
export function useChompOnRise(count, kind, ready = true) {
  const base = useRef(null);
  useEffect(() => {
    if (!ready) return;
    if (base.current !== null && count > base.current) playChomp(kind);
    base.current = count;
  }, [count, kind, ready]);
}
